export default [
  {
    path: "/examiner-dashboard",
    name: "examiner-main",
    component: () =>
      import("../../modules/Admin/pages/GroupList/GroupList.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["examiner", "academy"],
    },
  },
  {
    path: "/examiner-table/:group_id/:group_name",
    name: "examiner-table",
    component: () =>
      import("../../modules/Examiner/pages/ExaminerTable/ExaminerTable.vue"),
    meta: {
      layout: "main",
      auth: true,
      role: ["examiner", "academy"],
    },
  },
];
